import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { AIMS_API_BASE_URL } from "constants/constants"
import { getAccessToken } from "utils/token"

/**
 * RTK Query base instance for the AIMS backend (separate from the main DataBridges API).
 *
 * Base URL: REACT_APP_AIMS_API_URL (e.g. http://localhost:8000/)
 * All endpoints under /api/v1/aims/* should use relative paths to this base.
 */
const baseQuery = fetchBaseQuery({
  baseUrl: AIMS_API_BASE_URL,
  prepareHeaders: headers => {
    const token = getAccessToken()
    if (token) {
      headers.set("Authorization", `Bearer ${token}`)
    }
    return headers
  },
})

export const aimsBackendApi = createApi({
  reducerPath: "aimsBackendApi",
  baseQuery,
  tagTypes: [
    "AimsAsset",
    "AimsAssetList",
    "AimsAssetVocabulary",
    "AimsAssetStaged",
    "AimsContract",
    "AimsContractList",
    "AimsContractFilterOptions",
    "AimsContractAttachment",
    "AimsRound",
    "AimsRoundList",
    "AimsAssetCategory",
    "AimsAssetSubcategory",
    "AimsAssetDetail",
    "AimsAssetOutcome",
    "AimsAssetStatus",
    "AimsCountry",
    "AimsAdmin",
    "AimsRegionalBureau",
  ],
  endpoints: () => ({}),
})
